export default __webpack_public_path__ + "static/media/icon-kundennummer.23e6c8c0.svg";